import { useEffect, useState, useCallback, useRef } from "react";

import { CompanyInfo } from "../bitmaker/schemas/Billing/CompanyInfo";
import { useApiError } from "./useApiError";
import { BitmakerAPIClient } from "../services/BitmakerApp";

export const useCompanies = () => {
  const [companies, setCompanies] = useState<CompanyInfo[]>([]);
  const [loadingCompanies, setLoadingCompanies] = useState(false);
  const [fetchCompaniesError, setFetchCompaniesError] = useState<string | null>(
    null,
  );

  const { handleAPIError } = useApiError();
  const isMountedRef = useRef(false);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const fetchCompanies = useCallback(() => {
    if (!isMountedRef.current) return;

    setLoadingCompanies(true);
    setFetchCompaniesError(null);

    BitmakerAPIClient.get(
      "/billing/settings/company-info",
      null,
      (response) => {
        if (!isMountedRef.current) return;

        const { isError, message } = handleAPIError(response);

        if (isError) {
          console.error("Error fetching companies:", message);
          setFetchCompaniesError("Error fetching companies. Please try again.");
          setLoadingCompanies(false);
          return;
        }

        const data = Array.isArray(response.data) ? response.data : [];
        setCompanies(data);
        setLoadingCompanies(false);
      },
    );
  }, [handleAPIError]);

  useEffect(() => {
    fetchCompanies();
  }, [fetchCompanies]);

  return {
    companies,
    loadingCompanies,
    fetchCompaniesError,
    refetchCompanies: fetchCompanies,
  };
};
